import React from "react";
import "./style.css";
import logo from "../../Assets/Images/logo.svg";
import { useSelector } from "react-redux";
import { isValidString } from "../../helper";
import menu from "../../Assets/Images/sidebar/Frame.svg";
import ProfileImg from "../../Assets/Images/avatar.svg";
import { Link } from "react-router-dom";

const Header = (props) => {

  const user = useSelector(state => state.auth.user);
  const school = useSelector(state => state.common.schoolInfo)

  const schoolName = props?.school ?? school?.name;
  const city = props?.city ?? school?.city;
  return (
    <div className="header">
      <div className="header-content">
        <div className="logo d-flex">
          <div className={`menu d-flex align-items-center mx-3 ${props.dekstopSidebar === "hidden" ? 'd-none' : ''}`}>
            <div className="right-bars" onClick={props.showSidebar}>
              <img src={menu} alt="left-right" />
            </div>
          </div>
          <Link to="/dashbaord">
            <img src={isValidString(school?.image) ? school?.image : logo} alt="logo" />
          </Link>
        </div>
        <div className="text text-center">
          <p className="top-txt mb-0">{schoolName}</p>
          <p className="mb-0">{city}{(city && school?.state) ? "," : ""} {school?.state}</p>
        </div>
      </div>
      <div className="profile-mob">
        <div className="mob-header">
          {
            props.dekstopSidebar === "hidden" &&
            <div className="school-details">
              <Link to="/dashboard">
                <img src={isValidString(school?.image) ? school?.image : logo} alt="logo" className="w-100" />
              </Link>
              <div className="text text-center">
                <p className="top-txt mb-0">{schoolName}</p>
                <p className="mb-0">{city}{(city && school?.state) ? "," : ""} {school?.state}</p>
              </div>
            </div>
          }
          <div className={`right-bars ${props.dekstopSidebar === "hidden" ? 'd-none' : ''}`} onClick={props.showSidebar}>
            <img src={menu} alt="left-right" />
          </div>
          {
            props.dekstopSidebar === "hidden" ? "" : <h2>{props.title}</h2>
          }

        </div>
        <img src={isValidString(user?.profile_photo) ? user?.profile_photo : ProfileImg} alt="profile-pic" />
      </div>
    </div>
  );
};

export default Header;